import { basicEnum } from "./base";

export const DataImportTypeEnum = basicEnum([
    {
        label: "Pelanggan",
        value: "customer",
    },
]);

export namespace DataImportTypeEnum {
    export type Labels = (typeof DataImportTypeEnum)["labels"][number];
    export type Values = (typeof DataImportTypeEnum)["values"][number];
}
